import React from 'react';
import { PencilIcon, TrashIcon } from './Icons'; 

const TaskItem = ({ task, onToggle, onEdit, onDelete }) => {
  
  const getPriorityClass = (priority) => {
    switch (priority) {
      case 'high': return 'border-red-500';
      case 'medium': return 'border-yellow-500';
      case 'low': return 'border-green-500';
      default: return 'border-blue-500';
    }
  };

  return (
    <div className={`task-item bg-slate-800 bg-opacity-50 border-l-4 ${getPriorityClass(task.priority)} rounded-lg p-4 shadow-lg hover:bg-slate-700 transition-colors duration-300`}>
      <div className="flex items-start justify-between">
        <div className="flex items-start space-x-4 flex-1">
          <input 
            type="checkbox"
            checked={task.completed}
            onChange={() => onToggle(task)}
            className="mt-1 form-checkbox h-5 w-5 text-primary-gold bg-gray-700 border-gray-600 rounded focus:ring-primary-gold"
          />
          <div className="flex-1 min-w-0">
            <p className={`font-medium text-gray-100 ${task.completed ? 'line-through text-gray-500' : ''}`}>
                {task.title}
            </p>
            {task.description && (
              <p className="text-sm text-gray-300 mt-1 line-clamp-2">{task.description}</p>
            )}
            <div className="flex items-center space-x-4 mt-2 text-xs text-gray-300">
              {task.dueDate && (
                <span className={new Date(task.dueDate) < new Date() && !task.completed ? 'text-red-400 font-semibold' : ''}>
                    Vence: {new Date(task.dueDate + 'T00:00:00-03:00').toLocaleDateString()}
                </span>
              )}
              {task.completed && task.completedAt && (
                <span>Concluída: {new Date(task.completedAt.seconds * 1000).toLocaleDateString()}</span>
              )}
            </div>
          </div>
        </div>

        <div className="flex items-center space-x-1">
          {onEdit && (
            <button onClick={() => onEdit(task)} className="text-yellow-400 hover:text-yellow-300 p-2 rounded-full" title="Editar tarefa">
              <PencilIcon className="h-4 w-4" />
            </button>
          )}
          {onDelete && (
            <button onClick={() => onDelete(task)} className="text-yellow-400 hover:text-red-500 p-2 rounded-full" title="Excluir tarefa">
              <TrashIcon className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TaskItem;
